package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.network.ApiResult
import com.eladfinish.bible.contest.screens.mikud.api.MikudApi

class GetMikudFromServerUseCase(
    private val mikudApi: MikudApi,
) {

    suspend operator fun invoke(): String {
        return when (val content = mikudApi.getMikudFromServer()) {
            is ApiResult.ClientError -> content.throwable.toString()
            is ApiResult.Failure -> content.cause.toString()
            is ApiResult.Success -> content.data
        }
    }

}
